import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import CustomButton from './CustomButton';
import { View } from '../Base';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: 'flex',
    margin: `${typography.pxToRem(0)} ${typography.pxToRem(
      20
    )} ${typography.pxToRem(20)} ${typography.pxToRem(30)}`,
  },
  buttonsContainer: {
    display: 'flex',
    width: 'calc(100% - 16.625rem)',
    flexWrap: 'wrap',
  },
}));

const RouteManagementBottomOptions = ({
  buttonsConfig,
  customStyle,
  children,
}) => {
  const classes = useStyles();
  return (
    <View className={clsx(classes.container, customStyle?.container)}>
      <View className={classes.buttonsContainer}>
        <View>
          {buttonsConfig.map(
            (buttonItem) =>
              !buttonItem.isHidden && (
                <CustomButton
                  leftButton
                  title={buttonItem.title}
                  onClick={buttonItem.onClick}
                  disabled={buttonItem.isDisabled}
                  highlighted={buttonItem.highlighted}
                  key={buttonItem.title}
                />
              )
          )}
        </View>
      </View>
      {children}
    </View>
  );
};

export default React.memo(RouteManagementBottomOptions);
